module.exports = __webpack_public_path__ + "fonts/roboto-v27-latin-ext_latin-500.4f7c2d1.eot";